import StoreBuilder from '../store-builder';
import { InfosApi } from '@/api/infos';

const builder = new StoreBuilder('infos');

builder.addStatePart('versions', { backend: 'unknown', frontend: 'unknown' }, () => InfosApi.getVersion().catch(() => 'unknown').then(backend => ({ backend, frontend: process.env.VUE_APP_VERSION })), 'NONE', 1800);

export default builder.build();
